module.exports = __webpack_public_path__ + "img/noOrder.61c21664.png";